/** Match calendar weekday to plan `day` + `focus` labels (e.g. "Monday — Legs"). */
export function findPlanDayIndex(
  days: Array<{ day: string; focus: string }>,
  d = new Date(),
): number | null {
  const dow = d.getDay();
  const patterns = [
    /\b(sun|sunday)\b/i,
    /\b(mon|monday)\b/i,
    /\b(tue|tues|tuesday)\b/i,
    /\b(wed|wednesday)\b/i,
    /\b(thu|thur|thurs|thursday)\b/i,
    /\b(fri|friday)\b/i,
    /\b(sat|saturday)\b/i,
  ];
  const re = patterns[dow];
  if (!re) return null;
  for (let i = 0; i < days.length; i++) {
    const text = `${days[i]!.day} ${days[i]!.focus}`;
    if (re.test(text)) return i;
  }
  return null;
}

export function isLikelyRestOrConditioning(entry: { day: string; focus: string }): boolean {
  const s = `${entry.day} ${entry.focus}`.toLowerCase();
  return (
    /\brest\b/.test(s) ||
    /\boff\b/.test(s) ||
    /\brecovery\b/.test(s) ||
    /\bconditioning\b/.test(s) ||
    /\bcardio\b/.test(s) ||
    /\boptional\b/.test(s) ||
    /\bwalk\b/.test(s) ||
    /\bbike\b/.test(s)
  );
}
